<div
  class="balance-pill"
  tabindex="0"
  (click)="onBalanceClicked()"
  (keydown.enter)="onBalanceClicked()"
  [ngStyle]="balancePillStyles | theme"
>
  @let amount = balance();
  @if (amount?.iconPosition === "start" && amount?.icon; as icon) {
    <app-currency-icon [icon]="icon" sizeCss="--icon-medium" class="currency-icon" />
  }
  <span> {{ amount?.text }} </span>
  @if (!amount) {
    <ion-spinner name="crescent" />
  }
  @if (amount?.iconPosition === "end" && amount?.icon; as icon) {
    <app-currency-icon [icon]="icon" sizeCss="--icon-medium" class="currency-icon" />
  }
</div>
